
// @ts-nocheck
import locale_en_46json_0451f9ab from "#nuxt-i18n/0451f9ab";
import locale_es_46json_9463d259 from "#nuxt-i18n/9463d259";

export const localeCodes =  [
  "en",
  "es"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_0451f9ab",
      load: () => Promise.resolve(locale_en_46json_0451f9ab),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_9463d259",
      load: () => Promise.resolve(locale_es_46json_9463d259),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: false,
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "en-US",
      files: [
        {
          path: "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      language: "es-ES",
      files: [
        {
          path: "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/locales/es.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: false,
  langDir: "./locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "en-US",
    files: [
      {
        path: "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    language: "es-ES",
    files: [
      {
        path: "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/locales/es.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/